import { render, staticRenderFns } from "./euro-amount.vue?vue&type=template&id=f56571a8&scoped=true"
import script from "./euro-amount.vue?vue&type=script&lang=js"
export * from "./euro-amount.vue?vue&type=script&lang=js"
import style0 from "./euro-amount.vue?vue&type=style&index=0&id=f56571a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56571a8",
  null
  
)

export default component.exports